import { styled } from '@mui/system'

export const Header = styled('div')`
    display: flex;
    align-items: center;
    gap: 10px;
`
